import { useMemo } from 'react';

import { Actions } from '../../../constants/actionTypes';
import { useMainDispatch } from '../../useMainDispatch';
import { useMainSelector } from '../../useMainSelector';

export const useFacebookPages = () => {
  const {
    settings: { facebookPages, selectedFacebookPageId, facebookPageSettings },
  } = useMainSelector();

  const dispatch = useMainDispatch();

  const setSelectedFacebookPage = (selectedFacebookPageId: string) => {
    dispatch({
      type: Actions.SET_SETTINGS,
      payload: { selectedFacebookPageId },
    });
  };

  const selectedFacebookPage = useMemo(
    () => facebookPages.find((page) => page.id === selectedFacebookPageId),
    [facebookPages, selectedFacebookPageId],
  );

  return {
    facebookPages,
    setSelectedFacebookPage,
    selectedFacebookPage,
    facebookPageSettings,
  };
};
